function Banner() {
  return (
    <div
      className="relative w-full h-72"
      style={{
        background: "url('/images/banner_3.jpg')",
        backgroundSize: "cover",
        backgroundPositionX: "50%",
        backgroundPositionY: "25%",
      }}
    >
      <div className="w-full h-full flex items-center justify-center gap-10 bg-[rgba(0,0,0,.5)]">
        <div className="flex flex-col items-center">
          <div
            className="md:w-32 md:h-32 w-28 h-28 mb-5 "
            style={{
              background: "url('/images/logo.png')",
              backgroundSize: "cover",
              backgroundPositionY: "50%",
            }}
          ></div>
          <h1 className="text-white text-4xl hidden md:block">
            Next Generation
          </h1>
        </div>
      </div>
    </div>
  );
}

export default Banner;
